import { React, Component } from 'utils';
import { WhyStore } from 'model'
import Point from '../point';
import Hammer from 'react-hammerjs';
import './swiper.less';

const swiperClass = 'swiper';

export default class Swiper extends Component {

	constructor(props)
	{
		super(props);

		this.state = {
			active: 0,
			id: 'slider-' + Math.round(Math.random() * 1000000),
			items: this.props.items
		};

		this.offset = 0;
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			items: nextProps.items
		})
	}

	findPreviousIndex(active, total) {
		if(active > 0) {
			return active - 1;
		} else {
			return -1;
		}
	}

	findNextIndex(active, total) {
		if(active < total - 1) {
			return active + 1;
		} else {
			return -1;
		}
	}

	handleSwipe = (args) =>
	{
		console.log(args);

		var { direction } = args;
		var { items } = this.state;

		var { active } = this.state;
		var count = items.length;

		if (direction == 2) {
			//swipe left
			var next = this.findNextIndex(active, count);

			if(next == -1) {
				next = count - 1;
			}

			this.setState({
				active: next
			});
		} else if(direction == 4) {
			//swipe right
			var previous = this.findPreviousIndex(active, count);

			if(previous == -1) {
				previous = active;
			}

			this.setState({
				active: previous
			});
		}
	}

	componentDidMount() {
		var { id } = this.state;
		var slider = $('#' + id);
		this.repositionSlides(slider);
	}

	componentWillUnmount() {
		$('body').removeClass(swiperClass);
	}

	repositionSlides(slider) {

		var active = $('.active', slider);
		var slides = $('.slides', slider);

		var width = slider.width();
		var scaledWidth = width * 0.85;
		var offset = (width - scaledWidth) / 2;

		var { active } = this.state;

		this.offset = offset - active * scaledWidth;

		slides.animate({
			left: this.offset
		})
	}

	setupBody = (reposition) => {
		var { id } = this.state;
		var slider = $('#' + id);

		var { items } = this.props;

		if(items.length > 0) {
			if(!$('body').hasClass(swiperClass)) {
				$('body').addClass(swiperClass);
			}

			if(reposition) {
				this.repositionSlides(slider);
			}

		} else {
			$('body').removeClass(swiperClass);
		}
	}

	componentDidUpdate() {
		this.setupBody(true);
	}

	setActiveSlide = (index) => {
		this.setState({
			active: index
		});
	}

	nextSlide = () => {
		this.handleSwipe({ direction: 2 });
	}

	prevSlide = () => {
		this.handleSwipe({ direction: 4 });
	}

	render() {
		var { slide } = this.props;
		var { items } = this.state;
		var slides = null;
		var { active, id } = this.state;

		if(items.length > 0) {

			var count = items.length;
			var next = this.findNextIndex(active, count);
			var prev = this.findPreviousIndex(active, count);

			var onSelect = this.setActiveSlide;


			slides = items.map((item, index) => {

				var css = ['slide'];

				if(active == index) {
					css.push('active');
				}

				if(prev == index) {
					css.push('previous');
				}

				if(next == index) {
					css.push('next');
				}

				return <div key={ item.id } className={ css.join(' ') }>
					{ slide(item) }
				</div>;
			});

			this.setupBody(false);
		}

		var current = active + 1;
		var total = items.length;

		return <Hammer onSwipe={ this.handleSwipe } >
			<div>
				<div className="pager">
					<i
						className="fa fa-angle-left"
						aria-hidden="true"
						onClick={ this.prevSlide }
					/>
				<span className="numbers">
					{ current }/{ total }
				</span>
					<i
						className="fa fa-angle-right"
						aria-hidden="true"
						onClick={ this.nextSlide }
					/>
				</div>
				<div id={id} className="slider">
					<div className="slides" style={ { left: this.offset } }>
						{ slides }
					</div>
				</div>
			</div>
		</Hammer>;

	}
}

export function Slide({ item }) {

	var { content, name, imageUrl, title } = item;

	return <div>
		<span className="photo" style={{backgroundImage: 'url(' + imageUrl + ')'}}></span>
		<div className="scrollbox">
			<div className="photo">
				<div className="name">{ name }</div>
				<div className="title">{ title }</div>
			</div>
			<div className="content" dangerouslySetInnerHTML={{__html: content}}></div>
		</div>
	</div>
}




// WEBPACK FOOTER //
// ./src/modules/components/activities/swiper.js